import React from "react";
import { Box, Breadcrumbs, Container, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const PageBanner = ({ title, description, image, breadcrumbs = [] }) => (
  <Box
    sx={{
      position: "relative",
      overflow: "hidden",
      display: "flex",
      alignItems: "flex-end",
      color: "#fff",
      backgroundColor: "#122033",
      backgroundImage: `linear-gradient(120deg, rgba(10, 18, 30, 0.93), rgba(16, 29, 46, 0.82) 52%, rgba(28, 44, 67, 0.72)), url(${image})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      minHeight: { xs: 290, md: 360, lg: 390 },
      borderBottom: "1px solid rgba(255,255,255,0.08)",
      "&::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)",
        backgroundSize: "84px 84px",
        opacity: 0.14,
      },
    }}
  >
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(180deg, rgba(10, 18, 29, 0.06), rgba(10, 18, 29, 0.34) 48%, rgba(10, 18, 29, 0.84) 100%)",
      }}
    />
    <Container sx={{ position: "relative", zIndex: 1, py: { xs: 6.5, md: 8, lg: 9 } }}>
      <Stack spacing={1.8} sx={{ maxWidth: 780 }}>
        <Box className="eyebrow" sx={{ color: "rgba(255,255,255,0.92)", "&::before": { background: "linear-gradient(90deg, rgba(255,255,255,0.12), #dec095)" } }}>
          Refwa
        </Box>
      </Stack>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          color: "rgba(255,255,255,0.78)",
          mt: 2.4,
          mb: 2.2,
          fontSize: "0.9rem",
          "& .MuiBreadcrumbs-separator": {
            color: "primary.light",
          },
        }}
      >
        <RouterLink to="/">Home</RouterLink>
        {breadcrumbs.map((item) =>
          item.to ? (
            <RouterLink key={item.label} to={item.to}>
              {item.label}
            </RouterLink>
          ) : (
            <Typography key={item.label} color="inherit">
              {item.label}
            </Typography>
          )
        )}
      </Breadcrumbs>
      <Typography component="h1" variant="h2" sx={{ maxWidth: 720, textWrap: "balance" }}>
        {title}
      </Typography>
      {description ? (
        <Typography
          variant="body1"
          sx={{
            maxWidth: 690,
            mt: 1.8,
            color: "rgba(255,255,255,0.82)",
          }}
        >
          {description}
        </Typography>
      ) : null}
    </Container>
  </Box>
);

export default PageBanner;
